module.exports = __webpack_public_path__ + "static/media/note.332df312.png";